<main class="content-grades">
  <h2 class="title">Tus calificaciones</h2>
  <section *ngIf="hasGrades" class="grades-table">
    <table class="table">
      <thead>
        <tr class="titles">
          <th class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-7">Curso</th>
          <th class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-5">Calificación</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row" *ngFor="let course of courses.courses$ | async">
          <td class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-7 course-title" [routerLink]="['/cursos' + course.attributes.path.alias]">{{course.attributes.title}}</td>
          <td class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-5" *ngIf="!course.certificate"><span class="status-activo">En proceso</span></td>
          <td class="col-width-short" *ngIf="course.certificate"><span class="status-aprobado">Aprobado</span></td>
          <!-- <td class="col-width-short"><span class="status-cerrado">No aprobado</span></td> -->
        </tr>
      </tbody>
    </table>
  </section>
  <h1 *ngIf="!hasGrades" class="has-grades">No tienes cursos matriculados</h1>
</main>
